module.exports = __webpack_public_path__ + "img/NewsCenterDetails3_pic4.5e73eec2.png";